/** Public contact email (footer). Override with VITE_SITE_CONTACT_EMAIL in .env */
export const SITE_CONTACT_EMAIL =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_CONTACT_EMAIL?.trim()) || "info@ai-rd.ca";
